var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2747_35908)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2747_35908)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2747_35908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4833 9.41181C13.8846 8.62747 13.103 7.98432 12.2216 7.51372C11.3236 7.04312 10.3424 6.76076 9.32793 6.68232C8.31348 6.60389 7.28241 6.74507 6.33448 7.07449C5.38656 7.40391 4.50516 7.93726 3.79006 8.61179C3.07495 9.28631 2.50953 10.1177 2.16029 11.0118C1.79443 11.9374 1.66138 12.8942 1.72791 13.8511C1.81106 14.808 2.1104 15.7492 2.60931 16.5806C3.10822 17.4277 3.79006 18.1493 4.62157 18.714C4.92091 16.3453 6.0684 14.1335 7.84783 12.455C9.6439 10.7609 11.9721 9.69417 14.4833 9.41181Z",
    fill: "#FFEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.848 8.9098C17.0287 7.24701 18.8248 6.05483 20.8869 5.56854C20.4047 4.69009 19.6896 3.9685 18.8082 3.45084C17.9268 2.93318 16.8957 2.6665 15.8646 2.6665C14.8335 2.6665 13.8025 2.93318 12.9211 3.45084C12.0397 3.9685 11.3079 4.69009 10.8423 5.56854C12.9044 6.05483 14.7005 7.24701 15.8812 8.9098H15.848Z",
    fill: "#FFEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5369 11.0275C29.1876 10.1176 28.6222 9.30194 27.9071 8.62741C27.192 7.95288 26.3106 7.41954 25.3627 7.09012C24.3981 6.7607 23.3837 6.61952 22.3692 6.69795C21.3548 6.77638 20.357 7.05874 19.4756 7.52934C18.5775 7.99994 17.8126 8.6431 17.2139 9.42743C19.725 9.70979 22.0699 10.7922 23.8493 12.4706C25.6288 14.1491 26.7763 16.3609 27.0756 18.7296C27.9071 18.1649 28.5889 17.4276 29.0879 16.5962C29.5868 15.7492 29.8861 14.8236 29.9693 13.8668C30.0524 12.9099 29.9027 11.9373 29.5535 11.0432L29.5369 11.0275Z",
    fill: "#FFEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5732 17.1763H18.4922V22.8235H19.5732C19.8392 22.8235 19.939 22.7294 19.939 22.5097V17.5057C19.939 17.2704 19.8226 17.192 19.5732 17.192V17.1763Z",
    fill: "#FFEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8255 13.3955C20.9629 11.6386 18.4518 10.666 15.8242 10.666C13.1966 10.666 10.6854 11.6543 8.82286 13.3955C6.96027 15.1367 5.9292 17.5211 5.9292 19.9996C5.9292 22.4781 6.9769 24.8468 8.82286 26.6037C10.6854 28.3606 13.1966 29.3332 15.8242 29.3332C18.4518 29.3332 20.9629 28.3449 22.8255 26.6037C24.6881 24.8625 25.7192 22.4781 25.7192 19.9996C25.7192 17.5211 24.6715 15.1524 22.8255 13.3955ZM15.8242 22.5565H14.9594V24.0781H13.1135V22.5565H9.77078V20.9565L12.731 15.9054H14.6933L11.517 21.1918H13.1135V19.5917H14.9594V21.1918H15.8242V22.5565ZM21.8776 22.6663C21.8776 23.5448 21.3953 24.0938 20.1481 24.0938H16.5393V15.9211H20.1481C21.3953 15.9211 21.8776 16.4544 21.8776 17.3329V22.6663Z",
    fill: "#FFEAC7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2747_35908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2747_35908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2747_35908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4D);
export default __webpack_public_path__ + "static/media/icon4d.a0f80f7f88cc92dd546732a203178769.svg";
export { ForwardRef as ReactComponent };